import React, {useCallback, useEffect, useRef} from 'react';

import {StyledDialog, StyledDialogBody} from './styled';

interface TableDialogProps {
	show: boolean;
	children: React.ReactNode;
	onClose: () => void;
	width?: number;
	noOverflow?: boolean;
	title?: string | React.ReactNode;
	noGap?: boolean;
	id?: string;
}

const TableDialog: React.FC<TableDialogProps> = ({
	show,
	children,
	onClose,
	width,
	noOverflow = false,
	title,
	noGap = false,
	id,
	...rest
}) => {
	const dialogRef = useRef<HTMLDivElement | null>(null);
	const handleClose = useCallback(() => {
		onClose();
	}, [onClose]);

	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			const isTrustpilotDialogOpen = document.getElementById('trustpilot-dialog');
			const isReportDialogOpen = document.getElementById('report-dialog');
			const isSendSMSDialogOpen = document.getElementById('send-sms-dialog');
			const isInvoiceDialogOpen = document.getElementById('invoice-dialog');
			const isReleaseSimDialogOpen = document.getElementById('release-sim-dialog');

			if (
				isTrustpilotDialogOpen ||
					isReportDialogOpen ||
					isSendSMSDialogOpen ||
					isReleaseSimDialogOpen ||
					isInvoiceDialogOpen
					// isUserDialogOpen
			) {
				e.stopPropagation();
				return;
			}
		
			if (
				dialogRef.current &&
				e.target instanceof Node &&
				!dialogRef.current.contains(e.target)
			) {
				handleClose();
			}
		};
		
		document.addEventListener('mousedown', handleClickOutside, true);
		
		return () => {
			document.removeEventListener('mousedown', handleClickOutside, true);
		};
	}, [handleClose]);

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			const isTrustpilotDialogOpen = document.getElementById('trustpilot-dialog');
			const isReportDialogOpen = document.getElementById('report-dialog');
			const isSendSMSDialogOpen = document.getElementById('send-sms-dialog');
			const isInvoiceDialogOpen = document.getElementById('invoice-dialog');
			const isReleaseSimDialogOpen = document.getElementById('release-sim-dialog');

			if (isSendSMSDialogOpen || isInvoiceDialogOpen || isReleaseSimDialogOpen) {
				e.stopPropagation();
				return;
			}
			if ((isTrustpilotDialogOpen || isReportDialogOpen) && e.key === 'Escape') {
				e.stopPropagation();
				return;
			}
			if (e.key === 'Escape') {
				handleClose();
			}
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [handleClose]);

	return (
		<StyledDialog
			show={show}
			{...(width !== undefined ? {$width: width} : {})}
			$noOverflow={noOverflow}
			{...rest}
			{...title ? {title} : {}}
			$noGap={noGap}
			{...id ? {id} : {}}
		>
			<StyledDialogBody
				fullHeight
				ref={dialogRef}
				fullWidth
				direction="column"
				nowrap
				gap="none"
				$noOverflow={noOverflow}
				$noGap={noGap}
			>
				{children}
			</StyledDialogBody>
		</StyledDialog>
	);
}

export default TableDialog;
